export default "__VITE_ASSET__5244d52c__"